let lockDepth = 0
let previousOverflow = ''

export function lockBodyScroll() {
	if (typeof document === 'undefined') return () => {}

	const body = document.body

	if (lockDepth === 0) {
		previousOverflow = body.style.overflow
		body.style.overflow = 'hidden'
	}

	lockDepth += 1

	return function unlockBodyScroll() {
		lockDepth = Math.max(0, lockDepth - 1)

		if (lockDepth === 0) {
			body.style.overflow = previousOverflow
		}
	}
}
